<form [formGroup]="addTemplateForm">
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
      Save/Update Qualifying Template
      <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content>
      <mat-radio-group color="primary" aria-label="Select an option">
        <mat-radio-button value="0" (change)="OnCategoryChange(0)" [checked]="true" style="margin-right: 15px;">
          My Templates
        </mat-radio-button>
        <mat-radio-button value="2" *ngIf="isOfficeAdmin || isOrganizationAdmin" (change)="OnCategoryChange(2)"
          style="margin-right: 15px;">Save as Organization Template
        </mat-radio-button>
        <mat-radio-button value="1" *ngIf="isSuperAdmin" (change)="OnCategoryChange(1)">
          Save Global Template Only
        </mat-radio-button>
      </mat-radio-group>

      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start"
        (selectedTabChange)="getTabDetailsQuestionTemplate($event)">
        <mat-tab label="New">

          <div class="tabContainer">
            <div class="d-flex">

              <mat-form-field appearance="fill">
                <mat-label>Select Category</mat-label>
                <mat-select formControlName="folderID">
                  <mat-option *ngFor="let stat of filteredQualifyingCategoryList" [value]="stat.templateCategoryID">
                    {{ stat.templateCategoryName }}
                  </mat-option>
                </mat-select>

              </mat-form-field>

              <button class="addBtn" mat-icon-button color="primary" (click)="openDialogAddQuestionTemplate()">
                <mat-icon>add</mat-icon> </button>
            </div>
            <mat-form-field class="">
              <mat-label>Template Name</mat-label>
              <input matInput formControlName="taskTemplateName" maxlength="100" placeholder="Add Template Name" />
            </mat-form-field>
          </div>
        </mat-tab>

        <mat-tab label="Update Existing">
          <div class="tabContainer">

            <div class="searchSelectCat">
              <div class="selectCat">
                <mat-form-field class="example-full-width" appearance="fill">
                  <mat-label>Select Category</mat-label>
                  <mat-select [(value)]="selectedCategory" (selectionChange)="getSelectQuestionTemplate($event)">
                    <mat-option [value]="0">All</mat-option>
                    <mat-option *ngFor="let stat of filteredQualifyingCategoryList" [value]="stat.templateCategoryID">
                      {{ stat.templateCategoryName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>


              <div class="search">
                <mat-form-field class="example-full-width" appearance="fill">
                  <mat-label>Search</mat-label>
                  <input matInput maxlength="20" [(ngModel)]="searchTemplateQuestion" placeholder="Search Template"
                    (input)="searchTemplateForQuestion($event.target.value)">
                </mat-form-field>
              </div>
            </div>


            <div class="tempalteList">
              <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundQuestionTemplate">
                <tr>
                  <th class="formName">Template Name</th>
                  <th class="formName"></th>
                  <th class="actBtn">Action</th>
                </tr>
                <!-- [ngClass]="{ 'active': template.templateID === nlpTemplateID}" -->
                <tr *ngFor="let template of QualifyingTemplatesList"
                  [ngClass]="{ 'active': template.templateID === templateID}"
                  [ngStyle]="{ 'background-color': template.templateID === templateID ? '#e8f0fe' : 'transparent' }">

                  <td class="formName">
                    {{template.tempalteName}}
                  </td>

                   <td class="actBtn">
                    <span matTooltip="Total Questions">{{ template.questionCounts }}</span>
                  </td>

                  <td class="actBtn">
                  
                    <button mat-icon-button color="primary" mat-icon-button matTooltipClass="tooltip"
                      matTooltip="Select"
                      (click)="SelectTemplateForQuestionTemplate(template)"><mat-icon>post_add</mat-icon>
                    </button>
                  </td>
                </tr>
              </table>
              <div *ngIf="ShowNoRecordFoundQuestionTemplate" class="noRecordFound">No Records Found</div>
            </div>
          </div>

        </mat-tab>
      </mat-tab-group>

    </mat-dialog-content>

    <mat-dialog-actions *ngIf="showNew" align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeDialog()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="addTemplateForm.invalid || !addTemplateForm.dirty"
        (click)="AddQualifyingTemplate(addTemplateForm.value)">
        Add
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>

    <mat-dialog-actions *ngIf="showExisting" align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeDialog()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="!updateQuestionTemplateButton" (click)="updateQualifyingTemplateData()">
        Update
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>

</form>